var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 23,
    viewBox: "0 0 59 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.752 10.3011C58.3457 10.697 58.3457 11.5694 57.752 11.9652L42.5547 22.0976C41.8902 22.5406 41 22.0643 41 21.2655V18.0726C41 17.5203 40.5523 17.0726 40 17.0726H0.999999C0.447714 17.0726 0 16.6249 0 16.0726V5.20543C0 4.65315 0.447715 4.20543 1 4.20543H40C40.5523 4.20543 41 3.75771 41 3.20543V1.00168C41 0.202986 41.8901 -0.273405 42.5547 0.169631L57.752 10.3011Z",
    fill: "url(#paint0_linear_2648_28816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2648_28816",
    x1: 0,
    y1: 11.1336,
    x2: 58.1973,
    y2: 11.1336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#466FBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGradient);
export default __webpack_public_path__ + "static/media/arrow-gradient.abd45fa79d43dbcafcac8b5f640b9090.svg";
export { ForwardRef as ReactComponent };